import { BASE_ENDPOINT } from "../../../endpoint";

export const downloadIncomeStatementReportService = async (
	token: string,
	filters: { branchId: string[]; startDate: string; endDate: string },
	type: string,
): Promise<Blob> => {
	const reportType = type || "excel";
	const params = new URLSearchParams();
	filters.branchId.forEach((id) => {
		params.append("branchId", id);
	});
	params.append("startDate", filters.startDate);
	params.append("endDate", filters.endDate);
	params.append("type", reportType);
	try {
		const response = await fetch(
			`${BASE_ENDPOINT}/user/report/incomestatement/download?${params.toString()}`,
			{
				method: "GET",
				headers: {
					Authorization: `Bearer ${token}`,
					Accept:
						reportType === "pdf"
							? "application/pdf"
							: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
				},
			},
		);
		if (!response.ok) {
			console.error("Failed to download income statement report");
			throw new Error("Failed to download income statement report");
		}
		const blob = await response.blob();
		return blob;
	} catch (error) {
		console.error("API fetch error:", error);
		throw error;
	}
};
